import React, {useContext, useRef, useEffect} from 'react'
import { observer } from 'mobx-react-lite'
import ReactPlayer from 'react-player'
import axiosService from '../../../../../../utils/AxiosService'
import { DraftContext } from '../../../../../../contexts/DraftContext'
import { ChatSquareText } from 'react-bootstrap-icons'
import { useParams } from 'react-router-dom'
import { toastError } from '../../../../../FormComponents/Toasts'
import CommentLocation from '../../../../../../models/CommentLocation'
import CommentLocationMark from './DraftCommentsParts/CommentLocationMark'
import { useReadOnly } from '../../../../../../contexts/ReadOnlyContext'

export default observer(function VideoWindow() {
  const readOnly = useReadOnly()
  const { id, action_id } = useParams()
  const { draftState, selectedUpload, commentable } = useContext(DraftContext)
  const playerRef = useRef(null)

  const handleImageClick = (e) => {
    if (readOnly || !commentable) return

    const rect = e.currentTarget.getBoundingClientRect()
    const left = e.clientX - rect.left
    const top = e.clientY - rect.top
    const time = playerRef.current.getCurrentTime()

    axiosService.post(
      `/api/project_manager/campaigns/${id}/actions/${action_id}/draft_uploads/${selectedUpload.id}/draft_comment_locations`,
      { location: { top, left, time } }
    ).then(location => {
      selectedUpload.commentLocations.push(new CommentLocation(location))
      console.log('hiya')
      draftState.commentable = false
    }).catch(() => toastError('Could not add comment'))
  }

  const goToCommentTime = (time) => {
    playerRef.current.seekTo(time)
  }

  const getCommentLocations = () => {
    axiosService.get(
      `/api/project_manager/campaigns/${id}/actions/${action_id}/draft_uploads/${selectedUpload.id}/draft_comment_locations`,
      { params: {location_filter: 'active'} }
    )
      .then(locations => selectedUpload.commentLocations = locations.map(location => new CommentLocation(location)))
      .catch(error => console.log(error))
  }

  useEffect(() => getCommentLocations(), [selectedUpload.id, selectedUpload.commentLocations.length])


  return (
    <div className="flex items-center justify-center relative overflow-x-visible">
      {!readOnly && (
        <button
          className={`p-2 border-2 border-rb-green ${commentable ? 'bg-rb-green text-white dark:bg-rb-green dark:text-white' : 'bg-white dark:bg-rb-dark-mode text-rb-green dark:text-rb-green'} absolute top-0 left-3 rounded-lg`}
          onClick={(e) => {
            e.stopPropagation()
            draftState.toggleCommentable()
          }}
        >
          <ChatSquareText className='text-lg' />
        </button>
      )}
      <div
        className={`w-[450px] rounded-lg border-1 border-primary dark:border-rb-dark-mode-lighter relative ${commentable ? 'hover:cursor-pointer' : ''} overflow-x-visible p-2`}
        onClick={(e) => handleImageClick(e)}
      >
        {selectedUpload.commentLocations.map((location) => <CommentLocationMark key={location.id} location={location} goToCommentTime={goToCommentTime} />)}
        <ReactPlayer
          ref={playerRef}
          url={selectedUpload.url}
          width='100%'
          height='100%'
          controls={true}
        />
      </div>
    </div>

  )
})
